import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import URLConstants from '../../constants/urlConstants';

type SendMessage = {
    message: string;
}

type SendMessageState = {
    isLoading: boolean;
    error: boolean;
    sendMessage: SendMessage;
}

const initialState: SendMessageState = {
    isLoading: false,
    error: false,
    sendMessage: {
        message: ''
    },
}

const slice = createSlice({
    name: 'sendMessage',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // SEND MESSAGE
        sendMessageSuccess(state, action) {
            state.isLoading = false;
            state.sendMessage = action.payload;
        },
    }
});

// Reducer
export default slice.reducer;


export function sendNewMessage(to: any,from:string, type: string, templateName: any,whatsAppBusinessId:string,phoneNumberId:string, language: any, body: any, header: any, button: any) {

    if (Object.keys(header).length === 0) {
        header = null;
    }
    if (Object.keys(body).length === 0) {
        body = null;
    }

    return async () => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.post(URLConstants.SEND_MESSAGE_BASE_URL, { 'to': to[0].contactPhoneNumber,"from":"", 'type': type, 'templateName': templateName,"whatsAppBusinessId":whatsAppBusinessId,"phoneNumberId":"",'language':language ,'body': body, 'header': header,"button": button }
            );
            dispatch(slice.actions.sendMessageSuccess(response.data.data));
        } catch (error:any) {
            dispatch(slice.actions.hasError(error));
            return {message : error?.message, hasError : true} 
        }
    };

}